<template>
  <UIMobileBottomNavigation
    :items="menuItems"
    :is-visible="isVisible"
    @navigate="$emit('navigate')"
  />
</template>

<script setup lang="ts">
import { usePublisherSummaryStore } from "~/store/PublisherSummaryModule";
import type { MenuItem } from "~/components/UI/MobileBottomNavigation.vue";

import UINewIconsIBentoFour from "~/components/UINew/icons/IBentoFour.vue";
import UINewIconsIOrders from "~/components/UINew/icons/IOrders.vue";
import UINewIconsICardBalance from "~/components/UINew/icons/ICardBalance.vue";
import UINewIconsIMessages from "~/components/UINew/icons/IMessages.vue";

defineEmits<{ (e: "navigate"): void }>();

const summaryStore = usePublisherSummaryStore();

const route = useRoute();

const isVisible = computed<boolean>(() => {
  const authToken = useCookie("authorizedP").value;
  return !!(authToken && authToken !== '' && authToken !== 'undefined');
});

onMounted(() => {
  if (isVisible.value) {
    summaryStore.fetchSummary();
  }
});

watch(isVisible, (val) => {
  if (val) summaryStore.fetchSummary();
});

watch(
  () => route.path,
  () => {
    if (isVisible.value) summaryStore.fetchSummary();
  }
);

const channelsCount = computed(() => summaryStore.channelsCount);
const ordersCount = computed(() => summaryStore.ordersCount);
const newOrdersCount = computed(() => summaryStore.newOrdersCount);
const balance = computed(() => summaryStore.balance);
const unreadMessagesCount = computed(() => summaryStore.unreadMessagesCount);

const menuItems = computed<MenuItem[]>(() => [
  {
    path: "/publisher",
    label: "Каналы",
    icon: UINewIconsIBentoFour,
    exactMatch: true,
    badge: channelsCount.value > 0 ? channelsCount.value : undefined,
    badgeType: "gray",
  },
  {
    path: "/publisher/orders",
    label: "Заказы",
    icon: UINewIconsIOrders,
    badge: ordersCount.value > 0 ? ordersCount.value : undefined,
    badgeNew: newOrdersCount.value > 0 ? newOrdersCount.value : undefined,
    badgeType: "blue",
  },
  {
    path: "/publisher/payments",
    label: "Баланс",
    icon: UINewIconsICardBalance,
    badge: balance.value > 0 ? Math.round(balance.value) : undefined,
    badgeType: "gray",
  },
  {
    path: "/publisher/dialogs",
    label: "Диалоги",
    icon: UINewIconsIMessages,
    badge: unreadMessagesCount.value > 0 ? unreadMessagesCount.value : undefined,
    badgeType: "green",
  },
]);
</script>
